/**
 * @generated SignedSource<<7973aa419cae8008224f8839f5e63c87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectNoteCreateInput = {
  note: string;
  project_id: number;
};
export type NoteCreateMutation$variables = {
  note: ProjectNoteCreateInput;
};
export type NoteCreateMutation$data = {
  readonly action_project_note_create: {
    readonly note: {
      readonly created_at: string;
      readonly created_by: string | null | undefined;
      readonly creator_email: string | null | undefined;
      readonly id: number;
      readonly note: string;
      readonly project_id: number;
      readonly user_id: number | null | undefined;
    } | null | undefined;
    readonly project: {
      readonly id: number;
      readonly notes: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly notes_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
    } | null | undefined;
  };
};
export type NoteCreateMutation = {
  response: NoteCreateMutation$data;
  variables: NoteCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "note"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "note"
      }
    ],
    "concreteType": "ProjectNoteCreateOutput",
    "kind": "LinkedField",
    "name": "action_project_note_create",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "notes",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "note",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created_by",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creator_email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created_at",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "project_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "user_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "order_by",
                "value": {
                  "created_at": "asc"
                }
              }
            ],
            "concreteType": "notes",
            "kind": "LinkedField",
            "name": "notes",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": "notes(order_by:{\"created_at\":\"asc\"})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "notes_aggregate",
            "kind": "LinkedField",
            "name": "notes_aggregate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "notes_aggregate_fields",
                "kind": "LinkedField",
                "name": "aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteCreateMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "36761c14e6263ae1b4545e0e8566f53f",
    "id": null,
    "metadata": {},
    "name": "NoteCreateMutation",
    "operationKind": "mutation",
    "text": "mutation NoteCreateMutation(\n  $note: ProjectNoteCreateInput!\n) {\n  action_project_note_create(input: $note) {\n    note {\n      id\n      note\n      created_by\n      creator_email\n      created_at\n      project_id\n      user_id\n    }\n    project {\n      id\n      notes(order_by: {created_at: asc}) {\n        id\n      }\n      notes_aggregate {\n        aggregate {\n          count\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d73bae80b7535cd34e6156698c5a0036";

export default node;
